import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, lastValueFrom, of } from "rxjs";
import { NAVIGATE_ROUTES } from "../../global/constants";
import { ApiService } from "../api-service/api.service";
import { UtilsService } from "../utils-service/utils.service";
import { environment } from "src/environments/environment";
import { UserDetailsService } from "../user-details.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class HrmsSettingsService {
  res: any = [];
  apiEndPoint = NAVIGATE_ROUTES;
  filterData = new BehaviorSubject<any>({
    status: "",
    members: "",
    startDate: "",
    endDate: "",
  });
  resetLeave = new BehaviorSubject<any>("");
  getCustomFields = new BehaviorSubject<any>([]);
  recordLeaveType = "upcoming";
  resetCalendarSelection = new BehaviorSubject<boolean>(false);
  resetSelection$ = this.resetCalendarSelection.asObservable();

  constructor(
    private apiService: ApiService,
    public utilsService: UtilsService,
    public userDetailService: UserDetailsService,
    private http: HttpClient
  ) { }

  async getHRMSConfig(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_HRMS_CONFIG}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async setHRMSConfig(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = this.apiEndPoint.SET_HRMS_CONFIG;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getSandwichLeaveConfig(companyId: any): Promise<Observable<any>> {
    this.res = [];
    const url =
      this.apiEndPoint.GET_SANDWICH_LEAVE_CONFIG + `?companyId=${companyId}`;
    await this.apiService.get(url).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async setSandwichLeave(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = this.apiEndPoint.SET_SANDWICH_LEAVE_CONFIG;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async addLeaveType(data: any) {
    this.res = [];
    const url = this.apiEndPoint.ADD_LEAVE_TYPE;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async editLeaveType(data: any, leaveId: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ADD_LEAVE_TYPE}?id=${leaveId}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getLeaveDataById(
    companyId: any,
    leaveId: any
  ): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_LEAVE_INFO_BY_ID}?companyId=${companyId}&id=${leaveId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async deleteLeave(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.DELETE_LEAVE_TYPE}?companyId=${data.companyId}&id=${data.id}`;

    await this.apiService.delete(url).then((data) => {
      this.res = data;
    });
    return of(this.res);
  }

  async saveEmployeeConfig(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = this.apiEndPoint.SAVE_EMPLOYEE_LEAVE_CONFIG;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getEmployeeManagementConfig(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_EMPLOYEE_LEAVE_CONFIG}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async addHoliday(data: any) {
    this.res = [];
    const url = this.apiEndPoint.SET_HOLIDAY;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async editHoliday(data: any, holidayId: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.SET_HOLIDAY}?id=${holidayId}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getHolidayDataById(
    companyId: any,
    leaveId: any
  ): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.SET_HOLIDAY}?companyId=${companyId}&id=${leaveId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async deleteHoliday(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.SET_HOLIDAY}?companyId=${data.companyId}&id=${data.id}`;

    await this.apiService.delete(url).then((data) => {
      this.res = data;
    });
    return of(this.res);
  }

  async getLeaveApproveConfig(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.SET_LEAVE_APPROVE_CONFIG}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async setLeaveApproveConfig(data: any) {
    this.res = [];
    const url = this.apiEndPoint.SET_LEAVE_APPROVE_CONFIG;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getLeaveCalenderSetting(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_LEAVE_CALENDER_CONFIG
      }?companyId=${companyId}&offset=${this.utilsService.getOffsetTime()}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getLeaveTypeList(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_LEAVE_TYPE_LIST}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async applyLeave(data: any) {
    this.res = [];
    const url = this.apiEndPoint.APPLY_LEAVE;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getMyLeaveRecords(
    data: any,
    type: string,
    pageIndex: any,
    limit: number
  ): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_LEAVE_MY_LEAVE_RECORD;
    if (pageIndex) {
      url += `?page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getTodayLeaveRecords(data: any, startData: any, endDate: any): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_TODAY_LEAVE_RECORD + `?startDate=${startData}&endDate=${endDate}`;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }



  async getPendingApproveRecords(data: any, type: string, pageIndex: any, limit: number): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_PENDING_APPROVE_LEAVE_RECORD;
    if (pageIndex) {
      url += `?page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async approveRejectLeave(
    data: any,
    leaveId: any,
    type: any
  ): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.PENDING_APPROVE_LEAVE}?leaveId=${leaveId}&status=${type}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getTeamLeaves(
    data: any,
    pageIndex: any,
    limit: number
  ): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_TEAM_LEAVES;
    if (pageIndex) {
      url += `?page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async cancaltLeave(data: any, leaveId: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.CANCEL_LEAVE}?leaveId=${leaveId}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getUserLeaveRecords(
    data: any,
    pageIndex: any,
    limit: number,
    type?: string
  ): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_LEAVE_MY_LEAVE_RECORD;
    if (pageIndex) {
      url += `?page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async leaveDaysAvailability(
    start_date: any,
    end_date: any,
    leave_count: number,
    data: any
  ): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.CHECK_LEAVE_DAY_AVAILABILITY}?start_date=${start_date}&end_date=${end_date}&count=${leave_count}`;
    await this.apiService.post(url, data).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getTimesheetSettigns(): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_TIMESHEET_SETTIGNS
      }?offset=${this.utilsService.getOffsetTime()}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async setFinancialYear(data: any) {
    this.res = [];
    const url = this.apiEndPoint.SET_FINANCIAL_CONFIG;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getFinancialYear(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.SET_FINANCIAL_CONFIG}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async addTimeSheetHoliday(data: any, isOpenFromAttendance: boolean) {
    this.res = [];
    const url = isOpenFromAttendance
      ? this.apiEndPoint.SET_ATTENDANCE_TIMESHEET_HOLIDAY
      : this.apiEndPoint.SET_TIMESHEET_HOLIDAY;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async editTimeSheetHoliday(
    data: any,
    holidayId: any,
    isOpenFromAttendance: boolean
  ): Promise<Observable<any>> {
    this.res = [];
    const url = `${isOpenFromAttendance
      ? this.apiEndPoint.SET_ATTENDANCE_TIMESHEET_HOLIDAY
      : this.apiEndPoint.SET_TIMESHEET_HOLIDAY
      }?id=${holidayId}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getTimeSheetHolidayDataById(
    companyId: any,
    leaveId: any,
    isOpenFromAttendance: boolean
  ): Promise<Observable<any>> {
    const url = `${isOpenFromAttendance
      ? this.apiEndPoint.SET_ATTENDANCE_TIMESHEET_HOLIDAY
      : this.apiEndPoint.SET_TIMESHEET_HOLIDAY
      }?companyId=${companyId}&id=${leaveId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async deleteTimeSheetHoliday(
    data: any,
    isOpenFromAttendance: boolean
  ): Promise<Observable<any>> {
    this.res = [];
    const url = `${isOpenFromAttendance
      ? this.apiEndPoint.SET_ATTENDANCE_TIMESHEET_HOLIDAY
      : this.apiEndPoint.SET_TIMESHEET_HOLIDAY
      }?companyId=${data.companyId}&id=${data.id}`;

    await this.apiService.delete(url).then((data) => {
      this.res = data;
    });
    return of(this.res);
  }

  async getOpeningLeaveBalance(
    data: any,
    pageIndex: any,
    limit: number
  ): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.OPEN_LEAVE_BALANCE;
    if (pageIndex) {
      url += `?page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async saveOpenLeaveBalance(
    data: any,
    memberId: any
  ): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.SAVE_OPEN_LEAVE_BALANCE}?memberId=${memberId}`;
    await this.apiService.post(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async setMonthDate(data: any) {
    this.res = [];
    const url = this.apiEndPoint.SAVE_OPEN_LEAVE_MONTH;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getOpenBalanceData(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_LEAVE_OPEN_BALANCE}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getEmployeeBalanceData(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.GET_EMPLOYEE_LEAVE_OPEN_BALANCE}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getUserLeaveList(
    companyId: any,
    memberId: any,
    userId: any
  ): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.EMPLOYEE_LEAVE_BALANCE}?companyId=${companyId}&memberId=${memberId}&userId=${userId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async creditDeductLeave(data: any) {
    this.res = [];
    const url = this.apiEndPoint.CREDIT_DEDUCT_LEAVE;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async leaveActionRecords(
    data: any,
    type: string,
    pageIndex: any,
    limit: number
  ): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.ACTION_LEAVE_RECORD;
    if (pageIndex) {
      url += `?page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    if (type) {
      url += `&tab=${type}`;
    }
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getAttendanceConfig(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.ATTENDANCE_CONFIG}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async setAttendanceConfig(
    data: any,
    companyId: any
  ): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_CONFIG}?companyId=${companyId}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async setMemberConfig(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.MEMBER_ATTENDANCE_CONFIG}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getMemberConfig(companyId: any): Promise<Observable<any>> {
    this.res = [];
    const url =
      this.apiEndPoint.GET_MEMBER_ATTENDANCE_CONFIG + `?companyId=${companyId}`;
    await this.apiService.get(url).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getAttendanceMemberConfig(companyId: any): Promise<Observable<any>> {
    this.res = [];
    const url =
      this.apiEndPoint.MEMBERS_ATTENDANCE_CONFIG + `?companyId=${companyId}`;
    await this.apiService.get(url).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async addFaceImage(data: any) {
    this.res = [];
    const url = this.apiEndPoint.ADD_FACE_IMAGE;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async deleteFace(memberId: any, uuid: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.DELETE_FACE}?memberId=${memberId}&id=${uuid}`;

    await this.apiService.delete(url).then((data) => {
      this.res = data;
    });
    return of(this.res);
  }

  async addLocation(data: any) {
    this.res = [];
    const url = this.apiEndPoint.ATTENDANCE_LOCATION;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async editLocation(data: any, location: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_LOCATION}?id=${location}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async getLocationList(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.ATTENDANCE_LOCATION}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async setAttendanceApproveConfig(data: any) {
    this.res = [];
    const url = this.apiEndPoint.ATTENDANCE_APPROVE_CONFIG;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getAttendanceApproveConfig(companyId: any): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.ATTENDANCE_APPROVE_CONFIG}?companyId=${companyId}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getAttendanceShifts(): Promise<Observable<any>> {
    const url = this.apiEndPoint.ATTENDANCE_SHIFTS;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getAttendanceShiftById(id: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_SHIFTS}/${id}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = resData;
    });
    return of(this.res);
  }


  async createAttendanceShift(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = this.apiEndPoint.ATTENDANCE_SHIFTS;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = resdata;
    });
    return of(this.res);
  }

  async updateAttendanceShift(id: any, data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_SHIFTS}/${id}`;
    await this.apiService.put(url, data).then((resdata: any) => {
      this.res = resdata;
    });
    return of(this.res);
  }

  async updateAttendanceShiftWeekConfig(id: any, data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_SHIFTS}/${id}/weeks-config`;
    await this.apiService.put(url, data).then((resdata: any) => {
      this.res = resdata;
    });
    return of(this.res);
  }

  async deleteAttendanceShift(id: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_SHIFTS}/${id}`;
    await this.apiService.delete(url).then((resdata: any) => {
      this.res = resdata;
    });
    return of(this.res);
  }

  async deleteLocation(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_LOCATION}?id=${data.id}`;
    await this.apiService.delete(url).then((data) => {
      this.res = data;
    });
    return of(this.res);
  }

  async getCheckInOutLogList(data: any, is_day_wise_attendance: boolean) {
    this.res = [];
    if (!is_day_wise_attendance) {
      const url = `${this.apiEndPoint.ATTENDANCE_LOG_RECORDS}?startDate=${data.startDate}&endDate=${data.endDate}`;
      await this.apiService.post(url, data).then((resdata: any) => {
        this.res = [];
        this.res.push(resdata);
      });
    }
    if (is_day_wise_attendance) {
      const url = `${this.apiEndPoint.DAYWISE_ATTENDANCE_LOG_RECORDS}?startDate=${data.startDate}&endDate=${data.endDate}`;
      await this.apiService.post(url, data).then((resdata: any) => {
        this.res = [];
        this.res.push({ data: resdata });
      });
    }
    return of(this.res);
  }

  async applyAttendanceRegularization(data: any) {
    this.res = [];
    const url = this.apiEndPoint.APPLY_LEAVE_ATTENDANCE_REGULARIZATION;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getAttendanceRecordDay(data: any) {
    this.res = [];
    const url = this.apiEndPoint.ATTENDANCE_ADMIN_DAY_RECORDS;
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async updateAttendanceRecord(attendanceId: string, data: any) {
    this.res = [];
    const url = `${this.apiEndPoint.ATTENDANCE_ADMIN_RECORDS}/${attendanceId}`;
    await this.apiService.put(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async deleteAttendanceRecord(attendanceId: string, data: any) {
    this.res = [];
    const url =
      `${this.apiEndPoint.ATTENDANCE_ADMIN_RECORDS}/${attendanceId}` +
      `?member_id=${data.member_id}&date=${data.date}&offset=${encodeURIComponent(
        data.offset || ""
      )}`;
    await this.apiService.delete(url).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getRegularizationRecords(
    data: any,
    pageIndex: any,
    limit: number
  ): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.APPLY_LEAVE_ATTENDANCE_REGULARIZATION_RECORDS;
    if (pageIndex) {
      url += `?page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    await this.apiService.post(url, data).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getUserLeaveConfig(): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.CHECK_HRMS_ELIGIBILITY}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getUserLeaveReport(
    leaveId: any,
    startDate: any,
    endDate: any,
    userId: any,
    memberId: any
  ): Promise<Observable<any>> {
    let url = `${this.apiEndPoint.GET_USER_LEAVE_REPORT}?leaveId=${leaveId}`;
    if (userId) {
      url += `&user_id=${userId}`;
    }
    if (memberId) {
      url += `&member_id=${memberId}`;
    }
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getMemberLocationConfig(companyId: any): Promise<Observable<any>> {
    this.res = [];
    const url = this.apiEndPoint.LOCATION_CONFIG + `?companyId=${companyId}`;
    await this.apiService.get(url).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async setMemberLocationConfig(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.SET_LOCATION_PERMISSION}`;
    await this.apiService.put(url, data).then((resData) => {
      this.res = resData;
    });
    return of(this.res);
  }

  async deleteLeaveRegularization(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.DELETE_LEAVE_REGULARIZATION}?id=${data._id}`;
    await this.apiService.delete(url).then((data) => {
      this.res = data;
    });
    return of(this.res);
  }

  async deleteAttendanceRegularization(data: any): Promise<Observable<any>> {
    this.res = [];
    const url = `${this.apiEndPoint.APPLY_LEAVE_ATTENDANCE_REGULARIZATION}?id=${data._id}`;
    await this.apiService.delete(url).then((data) => {
      this.res = data;
    });
    return of(this.res);
  }

  async getTeamAttendanceWithCount(
    startData: any,
    endDate: any,
    assignedShiftId?: any
  ): Promise<Observable<any>> {
    this.res = [];
    const url =
      this.apiEndPoint.TEAM_ATTENDANCE_WITH_COUNT_REPORT +
      `?startDate=${startData}&endDate=${endDate}`;
    const body = {
      assigned_shift_id: Array.isArray(assignedShiftId) ? assignedShiftId : [],
    };
    await this.apiService.post(url, body).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async getOrgFinancialYear(): Promise<Observable<any>> {
    this.res = [];
    const url = this.apiEndPoint.GET_FINANCIAL_YEAR;
    await this.apiService.get(url).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  async fileUploadInS3Bucket(fileArr: any): Promise<string[]> {
    const finalURL: any[] = [];
    const fileArrURL = fileArr.map((fileData: any) => ({
      folderName: "/uploads",
      fileName: fileData.name,
      contentType: "." + fileData.name.split(".").at(-1),
    }));

    try {
      const observableRes = await this.userDetailService.getPresignURL(
        fileArrURL
      );
      const res: any = await lastValueFrom(observableRes);
      await Promise.all(
        fileArr.map(async (fileData: any, index: number) => {
          await this.userDetailService.s3MediaUpload(
            res?.urls[index]?.url,
            fileData
          );
          finalURL.push({
            data_path: res?.urls[index]?.url
              ?.replace(environment.MEDIA_BUCKET_NAME, environment.DOMAIN)
              .split("?")[0],
            size: fileArr[index]?.size,
            name: fileArr[index]?.name,
            type: "." + fileArr[index]?.name?.split(".").at(-1),
          });
        })
      );
      return finalURL;
    } catch (error) {
      console.error("Error in file upload:", error);
      return [];
    }
  }

  async getFaceAttachmentByMemberId(): Promise<Observable<any>> {
    this.res = [];
    const url = this.apiEndPoint.GET_USER_FACE_IMAGE;
    await this.apiService.get(url).then((resdata: any) => {
      this.res = [];
      this.res.push(resdata);
    });
    return of(this.res);
  }

  attendanceExportExcelFile(
    data: any,
    is_day_wise_attendance: boolean
  ): Observable<Blob> {
    if (!is_day_wise_attendance) {
      const url = `${this.apiEndPoint.ATTENDANCE_LOG_RECORDS}?startDate=${data.startDate
        }&endDate=${data.endDate}&offset=${encodeURIComponent(
          this.utilsService.getOffsetTime()
        )}`;
      return this.http.post(url, data, {
        responseType: "blob",
      });
    }

    if (is_day_wise_attendance) {
      const url = `${this.apiEndPoint.DAYWISE_ATTENDANCE_LOG_RECORDS
        }?startDate=${data.startDate}&endDate=${data.endDate
        }&offset=${encodeURIComponent(this.utilsService.getOffsetTime())}`;
      return this.http.post(url, data, {
        responseType: "blob",
      });
    }
  }

  teamAttendanceExportExcelFile(
    startData: any,
    endDate: any,
    assignedShiftId?: any,
    config?: any
  ): Observable<Blob> {
    const url =
      `${this.apiEndPoint.TEAM_ATTENDANCE_WITH_COUNT_REPORT}` +
      `?startDate=${startData}&endDate=${endDate}&isExport=true`;
    const body = {
      assigned_shift_id: Array.isArray(assignedShiftId) ? assignedShiftId : [],
      config: config || [],
    };
    return this.http.post(url, body, {
      responseType: 'blob',
    });
  }

  regularizationExportExcelFile(
    data: any,
    pageIndex: any,
    limit: number
  ): Observable<Blob> {
    let url =
      this.apiEndPoint.APPLY_LEAVE_ATTENDANCE_REGULARIZATION_RECORDS +
      `?isExport=true&offset=${encodeURIComponent(
        this.utilsService.getOffsetTime()
      )}`;
    if (pageIndex) {
      url += `&page=${pageIndex}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    return this.http.post(url, data, {
      responseType: "blob",
    });
  }
  leaveExportExcelFile(data: any, startData: any, endDate: any): Observable<Blob> {
    let url = this.apiEndPoint.GET_TODAY_LEAVE_RECORD + `?startDate=${startData}&endDate=${endDate}&isExport=true&offset=${encodeURIComponent(this.utilsService.getOffsetTime())}`;
    return this.http.post(url, data, {
      responseType: 'blob',
    });
  }

  async getMyLeaveRecordsExport(data: any, type: string): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_LEAVE_MY_LEAVE_RECORD;
    if (type) {
      url += `?type=${type}&isExport=true&offset=${encodeURIComponent(this.utilsService.getOffsetTime())}`
    }
    return this.http.post(url, data, {
      responseType: 'blob',
    });
  }

  async getTeamLeavesExport(data: any): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_TEAM_LEAVES + `?isExport=true&offset=${encodeURIComponent(this.utilsService.getOffsetTime())}`;

    return this.http.post(url, data, {
      responseType: 'blob',
    });
  }

  async getPendingApproveRecordsExport(data: any, type: string): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.GET_PENDING_APPROVE_LEAVE_RECORD;
    if (type) {
      url += `?type=${type}&isExport=true&offset=${encodeURIComponent(this.utilsService.getOffsetTime())}`
    }
    return this.http.post(url, data, {
      responseType: 'blob',
    });
  }

  async leaveActionRecordsExport(data: any, type: string): Promise<Observable<any>> {
    this.res = [];
    let url = this.apiEndPoint.ACTION_LEAVE_RECORD;
    if (type) {
      url += `?tab=${type}&isExport=true&offset=${encodeURIComponent(this.utilsService.getOffsetTime())}`
    }
    return this.http.post(url, data, {
      responseType: 'blob',
    });
  }

  async getUserLeaveExportReport(leaveId: any, startDate: any, endDate: any, userId: any, memberId: any): Promise<Observable<any>> {
    let url = `${this.apiEndPoint.GET_USER_LEAVE_REPORT}?isExport=true&leaveId=${leaveId}`;
    if (userId) {
      url += `&user_id=${userId}`
    } if (memberId) {
      url += `&member_id=${memberId}`
    }
    if (startDate) {
      url += `&startDate=${startDate}`
    }
    if (endDate) {
      url += `&endDate=${endDate}`
    }
    return this.http.get(url, {
      responseType: 'blob',
    });
  }

  async getShiftHistory(data: any): Promise<Observable<any>> {
    return this.http.post(this.apiEndPoint.SHIFT_HISTORY, data);
  }

}
